import TempSubscriberPassHandler from './temp_subscriber_pass_handler';

$(document).ready(() => {
  const signupGate = {
    designStandard: 'standard',
    designFullWidth: 'full-width',
    designFullWidthTracker: 'full-width-tracker',
    cssClass: window.cssClass,
    newsletter: window.siteName,
    tempSubscriberMark: '',
    siteName: window.siteName.toLowerCase().replace(/ /g, '_'),
    designType: window.designType,
    $contentGate: $('#content_gate_signup'),
    $overlay: $('#newspost_overlay'),
    articleBody: '.article-body',
    adClass: '.hybrid-ad-wrapper',
    $accessButton: $('#content_gate_button button'),
    confirmationLabel: '#confirmation',
    contentStart: 'article', // maybe not needed
    signupApiUrl: '/apisignup/',
    emailInputId: '#content_gate_input',
    $inputContainer: $('#input-container'),
    $signupList: $('#content_gate_signup .signup-list'),
    $signupInline: $('div[id*="inline-signup"]'),
    $signupFooter: $('.elevated-footer'),
    $signupFormErrorMessage: $('#content_gate_signup .signup-form-error-message'),
    $userConsentInput: $('#id_user_consent-gate'),
    $creditSection: $('.credits-section'),
    $socialTagsSection: $('.full-width__post-article-wrapper'),
    extraMargin: '4rem',
    originalMargin: '2rem',
    originalArticleHeight: $('.article-body').height(),
    firstAdSpotPosition: '450px',
    $previewCutoff: $('#content-gate-spot'),

    getGateProportionalPosition() {
      // The gate position is adjusted to maintain
      // a consistent preview area (in pixel squares)
      // for articles of varying lengths.
      const width = $('.article-body').width();
      const previewArea = 310 * 1000; // pixel squares
      const gatePosition = previewArea / width;
      return gatePosition;
    },

    showGateAndOverlay() {
      this.$overlay.show();
      this.$contentGate.show();
    },

    isTabletOrSmaller() {
      // 1024px (64em) is our medium breakpoint for tablet
      return $(window).width() <= 1024;
    },

    isMobile() {
      // 640px (40em) is our small breakpoint for mobile phones
      return $(window).width() <= 640;
    },

    setupMobileDesign() {
      if (this.isMobile()) {
        this.$signupList.insertAfter(this.emailInputId);
        this.$accessButton.css('font-size', '0.95rem');
        this.$overlay.css('height', '16rem');
      }
    },

    getFirstAdIndex() {
      // The first visible ad is the 'second' ad for the standard desktop design
      return !this.isTabletOrSmaller() && this.designStandard === this.designType ? 1 : 0;
    },

    hideFirstAd() {
      const adIndex = this.getFirstAdIndex();
      $(this.articleBody).children(this.adClass).eq(adIndex).hide();
    },

    fadeOutGate() {
      const $articleBody = $(this.articleBody);
      $articleBody.find('#newspost_overlay').fadeOut();
      $articleBody.animate(
        {
          'max-height': `${this.originalArticleHeight}`,
        },
        {
          duration: 1000,
          // Hide overflow while in transition.
          // Can't set this permenantly because it messes breakpoints
          // that editorial occastionaly uses. See ENGB-1324
          start: () => $articleBody.css({ overflow: 'hidden' }),
          done: () => $articleBody.css({ overflow: 'visible', 'max-height': '100%' }),
        },
      );
    },

    increasePaddingForSocialTags() {
      this.$socialTagsSection.css('margin-top', this.extraMargin);
    },

    decreasePaddingForSocialTags() {
      this.$socialTagsSection.css('margin-top', this.originalMargin);
    },

    hideCreditSection() {
      this.$creditSection.hide();
    },

    showCreditSection() {
      this.$creditSection.show();
    },

    hideFooterSignup() {
      this.$signupFooter.hide();
    },

    hideInlineSignups() {
      this.$signupInline.hide();
    },

    hideSignups() {
      this.hideInlineSignups();
      this.hideFooterSignup();
    },

    showConsentError() {
      this.$signupFormErrorMessage.show();
    },

    hideConsentError() {
      this.$signupFormErrorMessage.hide();
    },

    checkUserConsent() {
      return this.$userConsentInput.prop('checked');
    },

    // Most of this code is copied from the dive_mailcheck.js
    // Since this is a prototype, copying-pasting then modifying
    // for now.
    checkEmailAndRespond(textfield) {
      $(textfield).mailcheck({
        suggested(element, suggestion) {
          // remove old instances of the warning - anywhere on the page
          $('.js-already-subscriber-prompt').remove();
          $('.js-email-check').remove();

          const htmlToAdd = `<p class="email-check js-email-check padding-left">Did you mean <b>${suggestion.domain}</b>?</p>`;
          signupGate.$inputContainer.after(htmlToAdd);
        },
        empty() {
          $('.js-already-subscriber-prompt').remove();
          $('.js-email-check').remove();
          const htmlToAdd = '<p class="email-check js-email-check padding-left">Already a subscriber? Sign in with your email above.</p>';
          signupGate.$inputContainer.after(htmlToAdd);
        },
      });
    },

    setupEmailValidation() {
      $(this.emailInputId).on('blur', () => {
        signupGate.checkEmailAndRespond(signupGate.emailInputId);
      });
      signupGate.checkEmailAndRespond(signupGate.emailInputId);
    },

    getUTMParams() {
      // gets utm params from current url
      const urlParams = new URLSearchParams(window.location.search);
      const utmParams = {};
      const fields = ['utm_campaign', 'utm_medium', 'utm_source'];
      fields.forEach((field) => {
        if (urlParams.has(field)) {
          utmParams[field] = urlParams.get(field);
        }
      });
      return utmParams;
    },

    signup() {
      const email = $('#content_gate_input').val();
      if (typeof jstag !== 'undefined') {
        const payload = {
          email,
          _e: 'Email lookup',
        };
        // eslint-disable-next-line no-undef
        jstag.send(payload);
      }
      const externalReferrer = sessionStorage.getItem('externalReferrer');
      const referralUrl = externalReferrer !== 'direct' ? externalReferrer : window.location.href;
      const requestData = {
        email,
        list_name: this.newsletter,
        subscribe_requested: '1',
        source: 'content-gate',
        referral_url: referralUrl,
        signup_internal_referrer: window.location.href,
        ...this.getUTMParams(),
        ...(externalReferrer && externalReferrer !== 'direct' && { signup_external_referrer: externalReferrer }),
      };
      $.ajax({
        type: 'POST',
        url: this.signupApiUrl,
        data: requestData,
        success() {
          const handler = new TempSubscriberPassHandler();
          handler.setEditorialGateBypassToken();
        },
      });
    },

    updateMaxHeightForOverlay() {
      $(this.articleBody).css('max-height', this.getGateProportionalPosition());
    },

    showSuccessConfirmation() {
      const successConfirmation = `
      <div id="editorial_gate_confirmation" class="message message--success">
        Email submitted. <a class="analytics t-article-editorial-gate-success-message" href="https://divenewsletters.com/" target="_blank">Browse more newsletters</a>
        <img class="message__close" src="/static/img/components/messages/close.svg" alt="close">
      </div>`;

      // Appends the success message and fades it in
      $('.page-wrapper').append(successConfirmation);

      // Add event handler to close the confirmation
      // Normally, the click event handler is added in app.js
      // However, since we are adding the confirmation element late,
      // we need to add the event handler again here
      $('.message__close').click(function() {
        $($(this).closest('.message')).fadeOut('fast');
      });

      $('.message').fadeIn(1000);
    },

    hideSuccessConfirmation() {
      // Hide the success confirmation after 7 seconds
      setTimeout(() => {
        $('.message').fadeOut(1000, () => {
          // Hide the div after it fades out
          $('.message').hide();
        });
      }, 7000);
    },

    moveGate($htmlElement) {
      this.$contentGate.insertBefore($htmlElement);
    },

    moveGateBeforeCredits() {
      this.$contentGate.insertAfter($(this.articleBody));
    },

    moveGateToFirstTrackerItem() {
      const firstTrackerItem = $('.tracker-body-layout')[0];
      this.$contentGate.insertAfter(firstTrackerItem);
    },

    hideAllTrackerItems() {
      // Hide all tracker items except the first one
      $(this.articleBody).slice(1).hide();
    },
    addOverlayCss() {
      $(this.cssClass).addClass('overlay');
    },

    removeOverlayCss() {
      $(this.cssClass).removeClass('overlay');
    },

    addStructuredDataClass() {
    // Gated class is used to identify to google crawlers that this content is gated
    // in order to prevent a negative SEO hit. See ENGB-432, as well as the
    // structured data added in content_gate.html
      if (this.designType === this.designFullWidthTracker) {
        $('#tracker-container').addClass('gated');
      } else {
        $(this.cssClass).addClass('gated');
      }
    },

    removeContentGate() {
      if (this.designType === this.designFullWidthTracker) {
        this.$contentGate.hide();
        // show the confirmation message
        $('.message').fadeIn(1000);
        // make the first tracker item fully visible
        const firstTrackerItem = $('.tracker__body').first();
        // function to reveal all other tracker items
        const showRest = () => {
          $('.tracker__item').slice(1).show();
          firstTrackerItem.css('max-height', '100%');
        };
        firstTrackerItem.animate({
          'max-height': `${firstTrackerItem.height() * 2}`,
        }, 500, showRest);

        // show filter labels
        $('.filter-label').show();
        // enable filter dropdowns
        $('[id^="show-desktop-dropdown-"]').prop('disabled', false);
        $('.desktop-dropdown').removeClass('tracker_filter_disabled');
        $('.mobile-filter > select').prop('disabled', false);
        $('.mobile-filter').removeClass('tracker_filter_disabled');
        // enable mobile filter clear link and save button
        $('.clear-filters').removeClass('tracker_clear_link_disabled');
        $('#save-mobile-filter').removeClass('button--disabled save-disabled');
        $('#save-mobile-filter').prop('disabled', false);
        // fade out overlay
        $('#tracker-container').find(this.cssClass).first().find('#newspost_overlay')
          .fadeOut();
      } else {
        this.fadeOutGate();
        this.$contentGate.remove();
        this.showCreditSection();
        this.removeOverlayCss();
      }
      this.showSuccessConfirmation();
      this.hideSuccessConfirmation();
    },

    setUpContentGate() {
      // This is for debugging purposes needs to be removed before merging to main
      window.signupGate = this;
      // This is for styling purposes, not functional
      this.increasePaddingForSocialTags();
      this.hideCreditSection();
      // We want to hide certain signup placement as a part of business logic
      this.hideSignups();
      this.setupMobileDesign();

      if (this.designType === this.designFullWidthTracker) {
        // open the first tracker item
        $('.keep-reading-btn').first().click();
        this.moveGateToFirstTrackerItem();
        // hide all other tracker items
        $('.tracker__item').slice(1).hide();
        // hide filter labels
        $('.filter-label').hide();
        // disable filter dropdowns
        $('[id^="show-desktop-dropdown-"]').prop('disabled', true);
        $('.desktop-dropdown').addClass('tracker_filter_disabled');
        $('.mobile-filter > select').prop('disabled', true);
        $('.mobile-filter').addClass('tracker_filter_disabled');
        // disable mobile filter clear link and save button
        $('.clear-filters').addClass('tracker_clear_link_disabled');
        $('#save-mobile-filter').addClass('button--disabled save-disabled');
        $('#save-mobile-filter').prop('disabled', true);
        // hide all AD spots
        $(this.adClass).hide();
        // Finally show the gate
        $('#tracker-container').find(this.cssClass).first().append(this.$overlay);
        // Add structured data to tracker container
        this.addStructuredDataClass();
        this.showGateAndOverlay();
        const height = $('.tracker__body').first().outerHeight();
        // trigger this after 1 sec
        // we have to wait for the keep-reading-btn to expand the tracker__body
        setTimeout(() => {
          // we want the gate to be half the height of the tracker__body
          $('.tracker__body').first().css('max-height', height / 2);
        }, 500);
      } else {
        this.updateMaxHeightForOverlay();
        this.moveGateBeforeCredits();
        this.hideFirstAd();
        this.addOverlayCss();
        this.addStructuredDataClass();
        this.$overlay.appendTo(this.cssClass);
        // Finally show the gate and overlay
        this.showGateAndOverlay();
      }

      this.$contentGate.submit(() => {
        // eslint-disable-next-line no-restricted-globals
        event.preventDefault();
        signupGate.hideConsentError();
        if (!signupGate.checkUserConsent()) {
          signupGate.showConsentError();
          return false;
        }
        signupGate.signup();
        signupGate.removeContentGate();

        const contentGateSignupEventObjects = [
          // Standard Signup Event that is submitted on every newsletter signup
          {
            event: 'user.newsletterSignup',
            'user.newsletterSignup': {
              v: 12, // <-- DO NOT EDIT.
              name: 'EmailSignup-content-gate',
              location: 'content-gate', // emailSignupLocation to populate string
              signup_referrer: window.location.pathname, // page path the user signed up on
            },
          },
          // Content Gate specific signup event.
          // Audience want's both to make it easier to distringuish content gate signups
          {
            event: 'user.newsletter_signup_content_gate',
            'user.newsletter_signup_content_gate': {
              name: 'Newsletter Signup Content Gate',
              location: 'content-gate', // emailSignupLocation to populate string
              signup_referrer: window.location.pathname,
            },
          },
        ];

        contentGateSignupEventObjects.forEach((eventObject) => window.pushGTMEvent(eventObject));
        return true;
      });

      this.$userConsentInput.click(() => {
        signupGate.hideConsentError();
      });

      $(this.emailInputId).on('blur', () => {
        signupGate.checkEmailAndRespond(signupGate.emailInputId);
      });

      $(this.emailInputId).on('click, focus', () => {
        const $checkBoxList = signupGate.$signupList;
        const numberOfCheckboxes = $checkBoxList.children().length; // get number of checkboxes
        if (numberOfCheckboxes > 0) { // drop down list when clicking input
          $checkBoxList.slideDown('500');
        }
      });
    },
  };

  const lyticsCallback = function(profile) {
    // All sub lists follow the any_DIVE-NAME_subs format.
    // For example, Retail Dive is any_retail_dive_subs.
    // All trial lists follow the all_DIVE-NAME_trial_subscribers format.
    const usersAudienceArray = profile.data.user.segments;
    // we expect lytics segments to be in the format of `any_DIVE-NAME_subs`
    // so that we can check if the user is a subscriber or not.
    // where DIVE-NAME is lowercase, spaces replaced with underscores,
    // and dashes removed.
    // Examples
    // Retail Dive -> any_retail_dive_subs,
    // C-Store Dive-> any_cstore_dive_subs
    const diveName = window.siteName.toLowerCase()
      .replace(/ /g, '_')
      .replace(/-/g, '');
    const subList = `any_${diveName}_subs`;
    const trialList = `all_${diveName}_trial_subscribers`;
    const isSub = usersAudienceArray.indexOf(subList) > -1;
    const isTrial = usersAudienceArray.indexOf(trialList) > -1;

    const handler = new TempSubscriberPassHandler();
    if (isSub || isTrial || handler.hasValidToken()) {
      // Leave early given the user is a subscriber
      $('.preview-gate-message .with-gate').show();
      return;
    }
    $('.preview-gate-message .without-gate').show();
    signupGate.setUpContentGate();
  };

  const previewGatePage = window.previewGatePage === 'True';
  const showGatePreview = window.showGatePreview === 'True';

  // previewGatePage allows the user to preview the gate without enabling via a query param
  // when they are logged to the CMS, we force the gate into a certain state in that instance.
  if (previewGatePage && showGatePreview) {
    signupGate.setUpContentGate();
  } else if (!previewGatePage) {
    // lytics could not be loaded due to something like the adblocker/cookie banner,
    // so check to see if it's defined.
    if (typeof jstag !== 'undefined') {
      // eslint-disable-next-line no-undef
      jstag.call('entityReady', lyticsCallback);
    } else {
      // We default to showing the gate if we can't use Lytics to determine
      // if they are subbed or not
      signupGate.setUpContentGate();
    }
    // the preview-gate-message element is not there when the user is not logged in
    $('.preview-gate-message').css({ display: 'flex' });
  }
});
